import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage';
import reduxThunk from 'redux-thunk';

import rootReducer from '../reducers';
import { LOGOUT } from '../types';

const persistConfig = {
  key: 'root',
  blacklist: ['courseRed'],
  storage
}

const getMiddleware = () => {
  const middleware = [reduxThunk];

  return applyMiddleware(...middleware);
};

const appReducer = (state, action) => {
  let newState = state;

  if (action.type === LOGOUT) {
    localStorage.clear();
    newState = undefined;
  }

  return rootReducer(newState, action);
};

const persistedReducer = persistReducer(persistConfig, appReducer)

export default () => {
  let store = createStore(persistedReducer, getMiddleware())
  let persistor = persistStore(store)
  return { store, persistor }
}